import styles from "./index.module.scss";
import PriceInput from "../../../../Common/price-input/price-input.component";
import ModulesTable from "./modules-table";
import DistributorPricing from "./distributor-pricing";
import { AddDistributorDropdown } from "./add-distributor-dropdown";
import { mockModulesData } from "./modules-table/modules.mock-data";
import { mockDistributorsData } from "./add-distributor-dropdown/distributors.mock-data";
import MyModal from "../../../../Common/my-modal/my-modal.component";
import AddPlanFormWrapper from "./add-plan-form-wrapper";
import { getAddPlanFormInitialValues, IDistributorPricing } from "../../../../../common/validations/add-plan.validations";
import { AddPlanFormChildrenProps } from "./add-plan-form-wrapper";

interface ModalFormProps {
  onClose: () => void;
  onSubmit: (values: any) => void;
}

const ModalForm = ({ onClose, onSubmit }: ModalFormProps) => {
  const initialValues = getAddPlanFormInitialValues(mockModulesData);

  return (
    <AddPlanFormWrapper
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        values,
        setFieldValue,
        handleDistributorAdd,
        handleDistributorDelete,
        handleModuleChange,
        handleDistributorPricingChange,
        handleSubmit,
        isValid,
        isSubmitting,
      }: AddPlanFormChildrenProps) => (
        <>
          <MyModal.Body className={styles.modalBody}>
            <div className={styles.form}>
              <div className={styles.field}>
                <label
                  htmlFor="plan-name-input"
                  className={styles.label}
                >
                  Plan Name
                </label>

                <div className={styles.inputWrapper}>
                  <div className={styles.inputContainer}>
                    <input
                      id="plan-name-input"
                      type="text"
                      value={values.planName}
                      onChange={(e) => setFieldValue("planName", e.target.value)}
                      placeholder="e.g. Premium Buyers"
                      className={styles.input}
                      aria-label="Plan Name"
                    />
                  </div>
                </div>
              </div>
              <div className={styles.usersField}>
                <label
                  htmlFor="users-count"
                  className={styles.usersLabel}
                >
                  Users
                </label>

                <div className={styles.usersInputWrapper}>
                  <div className={styles.usersInputContainer}>
                    <PriceInput
                      id="users-count"
                      value={values.usersCount}
                      onChange={(value) => setFieldValue("usersCount", value)}
                      className={styles.usersInput}
                      aria-label="Number of users"
                    />
                  </div>
                </div>
              </div>
              <div className="divider" />
              <h3 className="f-12 line-height-18 f-600 f-black m-0">
                Modules Available
              </h3>
              <ModulesTable 
                modules={values.modules} 
                onModuleChange={handleModuleChange}
              />
              <div className="divider" />
              <h3 className="f-14 line-height-22 f-600 f-black m-0">
                Distributor Availability & Pricing
              </h3>
              {values.distributors.map((distributorPricing: IDistributorPricing) => (
                <DistributorPricing
                  key={distributorPricing.distributor.id}
                  distributorPricing={distributorPricing}
                  onDelete={() => handleDistributorDelete(distributorPricing.distributor.id)}
                  onPricingChange={(pricing) =>
                    handleDistributorPricingChange(distributorPricing.distributor.id, pricing)
                  }
                />
              ))}
              <AddDistributorDropdown 
                onDistributorAdd={handleDistributorAdd} 
                distributors={values.distributors.map((d: IDistributorPricing) => d.distributor)} 
                availableDistributors={mockDistributorsData}
              />
            </div>
          </MyModal.Body>
          <MyModal.Footer className="d-flex gap-4 border-top">
            <MyModal.CancelButton onClick={onClose}>Cancel</MyModal.CancelButton>
            <MyModal.ApplyButton 
              onClick={handleSubmit}
              disabled={!isValid || isSubmitting}
            >
              Create
            </MyModal.ApplyButton>
          </MyModal.Footer>
        </>
      )}
    </AddPlanFormWrapper>
  );
};

export default ModalForm;